import { render } from "./downloadUploadExcel.vue?vue&type=template&id=171f7f61&scoped=true"
import script from "./downloadUploadExcel.vue?vue&type=script&lang=js"
export * from "./downloadUploadExcel.vue?vue&type=script&lang=js"

import "./downloadUploadExcel.vue?vue&type=style&index=0&id=171f7f61&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171f7f61"]])

export default __exports__